import React from 'react';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { ModalContainer } from 'components/Modals/ModalContainer';
import { CONFIRM_EMAIL_MODAL_DATA } from 'shared/constants/modal-constants';
import { closeCurrentModal } from 'redux/slices/modals/modals.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal } from 'redux/selectors/selectors';
import { EModalsNames } from 'shared/types/modal.interface';
import { LinkExplanation } from '../LinkExplanation/LinkExplanation';

export const ConfirmEmailModal: React.FC = () => {
  const currentModal = useAppSelector(selectCurrentModal);
  const dispatch = useAppDispatch();

  if (currentModal.entityName !== EModalsNames.ConfirmEmailModal) return null;

  return (
    <ModalContainer
      onClose={() => dispatch(closeCurrentModal())}
      isOpen={currentModal.entityName === EModalsNames.ConfirmEmailModal}
    >
      <Stack alignItems="center" width="100%">
        <Typography
          variant="h2"
          color="primary.main"
          maxWidth="60%"
          sx={{ pb: { lg: '24px', md: '8px', sm: '8px', xs: '8px' } }}
        >
          {CONFIRM_EMAIL_MODAL_DATA.title}
        </Typography>
        <Typography
          variant="subtitle1"
          color="primary.main"
          textAlign="center"
          p={0}
          maxWidth="80%"
        >
          {`${CONFIRM_EMAIL_MODAL_DATA.subtitle}${currentModal.data.currentEmail}`}
        </Typography>
        {/* todo: add some logic onClick (fetch new link) */}
        <LinkExplanation onClick={() => dispatch(closeCurrentModal())} />
      </Stack>
    </ModalContainer>
  );
};
